import Bugsnag from "@bugsnag/js";
import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { ANALYTIC_EVENTS, sendAnalytics } from "@/utils/analytics";
import { showNotification } from "@/redux/actions/notification";
import { lenderResourceShareService } from "@/modules/contacts/features/lender/store/resource-share-services/lender-resource-share-service";

const downloadResourceShare = lenderResourceShareService.injectEndpoints({
  endpoints: builder => ({
    downloadResourceShare: builder.mutation({
      query: ({ lenderId, resourceShareId }) => ({
        url: `lenders/${lenderId}/resource-shares/${resourceShareId}/physical`,
        method: "GET",
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          const a = document.createElement("a");
          a.style.display = "none";
          a.href = data.url;
          a.download = data.file.fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          sendAnalytics(ANALYTIC_EVENTS.RESOURCE_SHARE_DOWNLOADED, data.file);

          dispatch(
            showNotification({
              ...DEFAULT_NOTIFICATION_PAYLOAD,
              message: {
                ...DEFAULT_NOTIFICATION_PAYLOAD.message,
                description: `${data.file.fileName} has been downloaded!`,
                options: {
                  variant: NOTIFICATION_VARIANTS.SUCCESS,
                },
              },
            }),
          );
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useDownloadResourceShareMutation } = downloadResourceShare;

